import { PersonaImageUpload, SwitchUi } from "../../ui";
import { Card, Col, Form, Row } from "antd";

export const AdicionalesProveedor = () => {
  return (
    <Card title="Foto" size="small" type="inner">
      <Row gutter={[8, 8]}>
        <Col span={24}>
          <Form.Item name={["persona", "image"]}>
            <PersonaImageUpload name={["persona", "image"]} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[8, 8]}>
        <Col span={12}>
          <Form.Item name="state" label="¿Está activo?" valuePropName="checked">
            <SwitchUi />
          </Form.Item>
        </Col>
      </Row>
    </Card>
  );
};
